import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarDaysIcon } from 'lucide-react';
import { eventsSection } from '../../data/homepage';
import { CategoryTag } from '../ui/CategoryTag';
import { PillButton } from '../ui/PillButton';
import { DecorPanel } from '../ui/DecorPanel';
export function EventsCalendar() {
  return <section aria-labelledby="calendrier-evenements" className="mx-auto w-full max-w-[1400px] px-5 py-14 lg:px-10" data-id="element-1754" data-mp="1melnwwrfpn15">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)] lg:gap-14" data-id="element-1755" data-mp="18n72ykdyvbrg">
        <DecorPanel tone="navy" curve={{
        variant: 'moon',
        placement: 'top-right',
        className: 'h-3/4 w-3/4'
      }} className="flex h-fit flex-col items-start p-8" data-id="element-1756" data-mp="1dhuw4wjx0ucd">
          <span className="grid h-12 w-12 place-items-center rounded-full bg-white text-ville-navy" aria-hidden="true" data-id="element-1757" data-mp="13nuj88ie6kt3">
            <CalendarDaysIcon className="h-6 w-6" data-id="element-1758" data-mp="tqpsdvdlq15y" />
          </span>
          <p className="mt-8 text-xs font-bold uppercase tracking-[0.12em] text-white/70" data-id="element-1759" data-mp="2iz44o1lopj86">
            {eventsSection.eyebrow}
          </p>
          <h2 id="calendrier-evenements" className="mt-2 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tight text-white lg:text-4xl" data-id="element-1760" data-mp="2dzhqnpy17yyb">
            {eventsSection.title}
          </h2>
          <PillButton to={eventsSection.cta.to} variant="orange" className="mt-8" data-id="element-1761" data-mp="2nwmio6ek6on1">
            {eventsSection.cta.label}
          </PillButton>
        </DecorPanel>

        <ul className="divide-y divide-slate-200 border-l-0 lg:border-l lg:border-slate-200 lg:pl-14" data-id="element-1762" data-mp="1vbcscy05966w">
          {eventsSection.items.map(item => <li key={item.id} className="py-8 first:pt-0 last:pb-0" data-id="element-1763" data-mp="25893lbhfg6f5">
              <CategoryTag label={item.category} data-id="element-1764" data-mp="255wduc5fgrrj" />

              <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-1765" data-mp="1hhd4dtan68xv">
                <h3 className="min-w-0 flex-1 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-ville-navy lg:text-3xl" data-id="element-1766" data-mp="1cjto6nudvm3a">
                  {item.title}
                </h3>
                <span className="shrink-0 bg-ville-mist px-4 py-2 text-sm font-bold uppercase tracking-wide text-ville-navy" data-id="element-1767" data-mp="2689ct6vm2905">
                  {item.date}
                </span>
              </div>

              <div className="mt-3 flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1" data-id="element-1768" data-mp="2fz3ya91194kj">
                <p className="min-w-0 text-[15px] text-slate-600" data-id="element-1769" data-mp="1j9d6ihk4lvif">{item.detail}</p>
                <p className="shrink-0 text-[15px] text-slate-500" data-id="element-1770" data-mp="1n9x4fncix35m">{item.place}</p>
              </div>

              {item.image && <div className="relative isolate mt-5 overflow-hidden" data-id="element-1771" data-mp="1s8i3vkjybit0">
                  <img src={item.image} alt="" className="h-64 w-full object-cover sm:h-80" data-id="element-1772" data-mp="1x8w2yd3kriew" />
                  <Link to={item.to} aria-label={`Voir l’événement : ${item.title}`} className="absolute bottom-4 right-4 grid h-11 w-11 place-items-center rounded-full bg-white text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2" data-id="element-1773" data-mp="33oybwst6ex5u">
                    <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1774" data-mp="n8s73ty9nv7v" />
                  </Link>
                </div>}
            </li>)}
        </ul>
      </div>
    </section>;
}